
        import Symbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-formbuilder_form",
  "use": "icon-rescls-formbuilder_form-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-formbuilder_form\"><path fill=\"#e1eaef\" d=\"M21 18V0H3v24h12z\" /><path fill=\"#81b0dc\" d=\"M15 18v6l6-6zM9.667 3H6.333A.333.333 0 0 0 6 3.333v3.333c0 .185.149.334.333.334h3.333A.333.333 0 0 0 10 6.667V3.333A.333.333 0 0 0 9.667 3M7.556 6.242 6.431 5.118l.471-.471.654.653 1.542-1.542.471.471zM12 4.5h6v1h-6ZM9.667 10H6.333a.333.333 0 0 0-.333.333v3.333c0 .185.149.334.333.334h3.333a.333.333 0 0 0 .334-.333v-3.334A.333.333 0 0 0 9.667 10m-2.111 3.242-1.125-1.124.471-.471.654.653 1.542-1.542.471.471ZM12 11.5h6v1h-6z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-formbuilder_form"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-formbuilder_form";

        export default Icon;
    